import { cn } from 'noddi-ui-common';

type Props = {
  completed: number;
  total: number;
  className?: string;
};

export const ReferralLevelStepper = ({ completed, total, className }: Props) => {
  if (total <= 0) {
    return null;
  }

  return (
    <div className={cn('flex gap-1', className)}>
      {Array.from({ length: total }, (_, index) => (
        <div key={index} className={cn('h-2 flex-1 rounded-full', index < completed ? 'bg-primary' : 'bg-muted')} />
      ))}
    </div>
  );
};
